module.exports = __webpack_public_path__ + "img/Icon material-thumb-up.ff08f264.svg";